// 箭頭顏色陣列
export const arrowColors = [
  '#FF6B6B', // 紅色
  '#4ECDC4', // 青色
  '#45B7D1', // 藍色
  '#96CEB4', // 綠色
  '#FFEAA7', // 黃色
  '#DDA0DD', // 紫色
  '#98D8C8', // 薄荷綠
  '#F7DC6F', // 金黃色
  '#BB8FCE', // 淡紫色
  '#85C1E9', // 天藍色
  '#F8C471', // 橙色
  '#82E0AA', // 淺綠色
  '#F1948A', // 粉紅色
  '#85C1E9', // 淺藍色
  '#D7BDE2', // 淡紫紅色
];
// SVG 配置
export const svgConfig = {
  width: 800,
  height: 500,
  nodeHeight: 40,
  nodeWidth: 120,
  nodeSpacing: 20,
  rowSpacing: 80,
  startX: 50,
  startY: 80,
  capsuleRadius: 20,
};
const getY = (rowIndex) => {
  switch (rowIndex) {
    case 0:
      return svgConfig.startY;
    case 1:
      return svgConfig.startY + 150;
    case 2:
      return svgConfig.startY + 230;
    default:
      break;
  }
};
// 生成節點位置
export const generateNodePositions = (items, rowIndex) => {
  const { startX, nodeWidth, nodeSpacing } = svgConfig;

  // 為第一行設備節點添加右偏移，避免完全垂直的箭頭
  const deviceOffset = rowIndex === 0 ? 60 : 0; // 第一行設備往右偏移 60px
  return items.map((item, index) => ({
    id: item.id,
    name: item['項目'] || item['區段腳本名稱'] || '',
    x: startX + index * (nodeWidth + nodeSpacing) + deviceOffset,
    y: getY(rowIndex),
  }));
};

// 生成膠囊形狀的路徑
export const generateCapsulePath = (x, y, width, height, radius) => {
  const halfHeight = height / 2;
  return `
      M ${x + radius} ${y}
      L ${x + width - radius} ${y}
      Q ${x + width} ${y} ${x + width} ${y + halfHeight}
      L ${x + width} ${y + height - halfHeight}
      Q ${x + width} ${y + height} ${x + width - radius} ${y + height}
      L ${x + radius} ${y + height}
      Q ${x} ${y + height} ${x} ${y + height - halfHeight}
      L ${x} ${y + halfHeight}
      Q ${x} ${y} ${x + radius} ${y}
      Z
    `;
};

// 生成箭頭路徑（帶偏移）
export const generateArrowPath = (startX, startY, endX, endY, offset = 0) => {
  // 計算中間控制點，添加偏移量
  const midX = (startX + endX) / 2;
  const midY = (startY + endY) / 2 + offset;

  return `
      M ${startX} ${startY}
      Q ${midX} ${midY} ${endX} ${endY}
    `;
};

// 生成箭頭三角形（帶偏移）
export const generateArrowTriangle = (
  startX,
  startY,
  endX,
  endY,
  offset = 0,
) => {
  const arrowSize = 12;

  // 計算方向向量（考慮曲線的切線方向）
  const midX = (startX + endX) / 2;
  const midY = (startY + endY) / 2 + offset;

  // 計算曲線在終點處的切線方向
  const tangentX = endX - midX;
  const tangentY = endY - midY;
  const length = Math.sqrt(tangentX * tangentX + tangentY * tangentY);

  if (length === 0) return '';

  // 正規化切線方向向量
  const unitX = tangentX / length;
  const unitY = tangentY / length;

  // 計算箭頭的兩個側邊點
  const perpX = -unitY;
  const perpY = unitX;

  const arrowTipX = endX;
  const arrowTipY = endY;

  const arrowLeftX = endX - unitX * arrowSize - (perpX * arrowSize) / 2;
  const arrowLeftY = endY - unitY * arrowSize - (perpY * arrowSize) / 2;

  const arrowRightX = endX - unitX * arrowSize + (perpX * arrowSize) / 2;
  const arrowRightY = endY - unitY * arrowSize + (perpY * arrowSize) / 2;

  return `
      M ${arrowLeftX} ${arrowLeftY}
      L ${arrowTipX} ${arrowTipY}
      L ${arrowRightX} ${arrowRightY}
      Z
    `;
};
